export default {
  /**
   * Set Teacher application approval list.
   *
   * @param state
   * @param items
   */
  setTeacherAwayApplicationApprovalList(state, items) {
    console.log("Items: ", items);
    state.items = items;
  },

  /**
   * Pagination.
   *
   * @param state
   * @param pagination
   */
  setTeacherAwayApplicationApprovalListPagination(state, pagination) {
    console.log("Pagination: ", pagination);
    state.pagination = pagination;
  },

  /**
   * Set current page.
   *
   * @param state
   * @param page
   */
  setTeacherAwayApplicationApprovalListPage(state, page) {
    state.pagination.current_page = page;
  },

  /**
   *
   * @param state
   * @param isBusy
   */
  setTeacherAwayApplicationApprovalListBusy(state, isBusy) {
    state.isBusy = isBusy;
  },
};
